<template>
  <v-app>
    <FullHeaderComponent />
    <v-main class="grey lighten-4">
      <v-container fill-height fluid class="account-bg">
        <v-row>
          <v-col cols="12">
            <h2 class="text-h1 pt-9 pb-6 text-center font-weight-black">404</h2>
            <div class="outlined text-center">{{ $t("404") }}</div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <CopyrightComponent />
  </v-app>
</template>

<script>
// @ is an alias to /src
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";

export default {
  name: "404",
  components: {
    FullHeaderComponent,
    CopyrightComponent
  }
};
</script>

<style scoped>
.account-bg {
  background-image: url("../assets/images/bg.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}
</style>
